import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const MealPlanningSection = ({ upcomingMeals, onPlanMeal, onViewRecipes }) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Icon name="CalendarDays" size={20} color="var(--color-primary)" />
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Meal Planning
          </h3>
        </div>
        <Button
          variant="outline"
          size="sm"
          iconName="Plus"
          onClick={onPlanMeal}
        >
          Plan Meal
        </Button>
      </div>
      <div className="space-y-4">
        {upcomingMeals?.map((meal) => (
          <div 
            key={meal?.id}
            className="flex items-center gap-4 p-4 bg-muted/50 rounded-lg transition-smooth hover:bg-muted"
          >
            <div className="flex-shrink-0 h-16 w-16 md:h-20 md:w-20 rounded-lg overflow-hidden bg-background">
              <Image
                src={meal?.image}
                alt={meal?.imageAlt}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs caption px-2 py-0.5 bg-primary/10 text-primary rounded-full">
                  {meal?.date}
                </span>
                <span className="text-xs caption px-2 py-0.5 bg-accent/10 text-accent rounded-full capitalize">
                  {meal?.category}
                </span>
              </div>
              <p className="text-sm md:text-base font-medium text-foreground mb-1">
                {meal?.name}
              </p>
              <div className="flex items-center gap-4 text-xs md:text-sm caption text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Flame" size={14} />
                  {meal?.calories} kcal
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="Clock" size={14} />
                  {meal?.prepTime} min
                </span>
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {}}
              className="flex-shrink-0"
            >
              <Icon name="ChevronRight" size={20} />
            </Button>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <Button
          variant="outline"
          onClick={onViewRecipes}
          iconName="BookOpen"
          iconPosition="left"
          fullWidth
        >
          Browse Recipe Library
        </Button>
      </div>
    </div>
  );
};

export default MealPlanningSection;